/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'pen': {
    width: 31,
    height: 31,
    viewBox: '0 0 31 31',
    data: '<g _fill="#813CCF" fill-rule="evenodd"><circle pid="0" fill-opacity=".1" cx="15.5" cy="15.5" r="15.5"/><path pid="1" d="M17.056 10.147l3.796 3.794.362-.361a2.681 2.681 0 000-3.794 2.685 2.685 0 00-3.797 0l-.361.361zm3.036 4.554l-3.796-3.794-5.495 5.492 3.796 3.794 5.495-5.492zm-11.08 6.738a.472.472 0 00.125.435c.09.072.2.126.326.126.036 0 .072-.018.108-.018l4.194-1.03h.018c0-.018.019-.018.019-.018l-3.742-3.74c-.018.017-.018.017-.018.035v.019l-1.03 4.19z"/></g>'
  }
})
